import { createColumnHelper } from '@tanstack/react-table';
import { ICustomerRow } from '@westondev/tableturn-core';

export const columnHelper = createColumnHelper<ICustomerRow>();

export const ROW_ID_PREFIX = 'customer-main-screen-row-';
